import React from "react";
import { useMediaQuery } from "react-responsive";
import Hero from "./hero-section/hero";
import AboutUs from "./aboutus-section/aboutUs";
import Market from "./market-section/market";
import News from "./news/news";
import RoadMap from "./roadmap-section/roadmap";
import NewsLetter from "../news-letter";
import Teams from "./../teams/index";
import SocialWidgets from "../social-widgets";
import GithubStatsDesktop from "../github-stats/desktop-view";
import GithubStatsMobile from "../github-stats/mobile-view";

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 992 });
  return isDesktop ? children : null;
};

const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ maxWidth: 991 });
  return isTablet ? children : null;
};

const Home = () => {
  return (
    <div className="container">
      <div className="row m-0">
        <div className="col-12 p-0">
          <div className="row m-0">
            <div className="col-12 p-0">
              <Hero />
            </div>
          </div>
          <div className="row m-0 pb-5">
            <div className="col-lg-3 social-widgets-wrapper">
              <Desktop>
                <SocialWidgets />
              </Desktop>
            </div>
            <div className="col-lg-9 pl-lg-5 pr-lg-2">
              <AboutUs />
              <Market />
              <News />
              <div>
                <Desktop>
                  <GithubStatsDesktop />
                </Desktop>

                <Tablet>
                  <GithubStatsMobile />
                </Tablet>
              </div>
              <RoadMap />
              <NewsLetter />
              <Teams />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
